import styled from 'styled-components';

interface Props {
	selectedCount: number;
	onAssign: () => void;
	onClear: () => void;
	disabled?: boolean;
}

const Bar = styled.div`
	display: flex;
	align-items: center;
	gap: 16px;
	border-radius: 8px;
	border: 1px solid #bfdbfe;
	background: #eff6ff;
	padding: 8px 16px;
	box-shadow: 0 1px 2px rgb(0 0 0 / 0.05);
`;

const CountLabel = styled.span`
	font: ${p => p.theme.ticketing.font.subheading2};
	font-weight: 500;
	color: #334155;
`;

const AssignButton = styled.button`
	border: 0;
	border-radius: 4px;
	background: #2563eb;
	padding: 6px 12px;
	font: ${p => p.theme.ticketing.font.subheading2};
	font-weight: 500;
	color: #ffffff;
	cursor: pointer;
	&:hover {
		background: #1d4ed8;
	}
	&:focus {
		outline: none;
		box-shadow: 0 0 0 2px #ffffff, 0 0 0 4px #3b82f6;
	}
	&:disabled {
		cursor: not-allowed;
		opacity: 0.5;
	}
`;

const ClearButton = styled.button`
	border: 0;
	background: transparent;
	padding: 0;
	font: ${p => p.theme.ticketing.font.subheading2};
	font-weight: 500;
	color: #64748b;
	cursor: pointer;
	&:hover {
		color: #334155;
	}
	&:focus {
		outline: none;
		text-decoration: underline;
	}
`;

export function BulkActionBar({selectedCount, onAssign, onClear, disabled}: Props) {
	return (
		<Bar>
			<CountLabel>{selectedCount} selected</CountLabel>
			<AssignButton type="button" onClick={onAssign} disabled={disabled}>
				Assign selected
			</AssignButton>
			<ClearButton type="button" onClick={onClear}>
				Clear selection
			</ClearButton>
		</Bar>
	);
}
